var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"slider"}},[_c('VueCompareImage',{attrs:{"leftImage":"../facemask.png","rightImage":"../face.png","sliderLineWidth":0,"handleSize":80}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }